/* eslint-disable react/no-unescaped-entities */
import { LIST_TYPE } from "@/shared/types/atoms.types";
import React from "react";
import ListSection from "../atoms/ListSection";
import TermsParagraph from "../atoms/TermsParagraph";

interface EligibilityListProps {}

const EligibilityList: React.FC<EligibilityListProps> = () => {
  return (
    <div>
      <ListSection
        listIndex="1.1."
        description="You must be at least 18 years of age."
        listType={LIST_TYPE.LIST2}
      />
      <ListSection
        listIndex="1.2."
        listType={LIST_TYPE.LIST2}
        description={
          <TermsParagraph>
            You must register Yourself as an Affiliate through Graphy’s
            Affiliate signup page at{" "}
            <a href="https://partners.ongraphy.com/" target="_blank">
              https://partners.ongraphy.com/
            </a>{" "}
            <b>(“Graphy Affiliate Page”)</b>. Once registered as an Affiliate, a
            referral link which is unique to Your affiliate account will be made
            available to You <b>(“Referral Link”)</b>.
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="1.3."
        listType={LIST_TYPE.LIST2}
        description="You may refer friends, followers, or anyone sharing with them the Referral Link via the Platform, email or otherwise. "
      />

      <TermsParagraph className="ml-2 md:ml-6">
        Please note that we will always have the right to reject Your
        application or terminate Your access to the Graphy Affiliate Page/Your
        account therein, if we determine (in our sole discretion) that Your
        promotional methods or the platforms where You choose to promote Graphy
        or its Services through Your Referral Link, are not suitable for the
        Affiliate Program for any reason, including, but not limited to, its
        inclusion of content that is unlawful or otherwise violates our Platform
        Terms.
      </TermsParagraph>
    </div>
  );
};

EligibilityList.displayName = "EligibilityList";

export default EligibilityList;
